import { users } from '@constants/endpoints';
import { store } from '@store/index';
import { unsetUserDetails } from '@store/slices/user.slice';
import { getAccessToken, getUserId } from '@utils/helpers';
import axios, { AxiosError } from 'axios';
import { t as translate } from 'i18next';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';

const headers = {
  'Content-Type': 'application/json',
  'x-client-id': import.meta.env.VITE_CLIENT_ID,
  'x-country-id': import.meta.env.VITE_COUNTRY_ID,
  'x-project-id': import.meta.env.VITE_PROJECT_ID,
};

const loginInstance = axios.create({
  baseURL: import.meta.env.VITE_CLIENT_SERVICE_URL,
  timeout: 50000,
  headers,
});

// Create an axios instance
const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_CLIENT_SERVICE_URL,
  timeout: 50000,
  headers,
});

loginInstance.interceptors.request.use(
  (config) => {
    config.headers.Authorization = `Bearer ${getAccessToken()}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Request Interception
axiosInstance.interceptors.request.use(
  (config) => {
    config.baseURL = `${config.baseURL}${users}/${getUserId()}`;
    config.headers.Authorization = `Bearer ${getAccessToken()}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axiosInstance.interceptors.response.use(undefined, (error: AxiosError) => {
  const { response, message } = error || {};

  // toast error
  const errMsg =
    response?.data?.errors?.[0] ||
    response?.data?.error ||
    message ||
    translate('sys.api.errorMessage');
  toast.error(errMsg);

  const status = response?.status;
  if (status === 401) {
    Cookies.remove('ca_token');
    Cookies.remove('uuid_dp');
    store.dispatch(unsetUserDetails());
  }
  return Promise.reject(error);
});

export { axiosInstance, loginInstance };
